/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */

export type ESMDefectSeverity =
    (typeof ESMDefectSeverity)[keyof typeof ESMDefectSeverity];

export const ESMDefectSeverity = {
    Minor: 0,
    Major: 1,
    Critical: 2,
} as const;
